import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import MuiTheme from 'styles/theme/MuiTheme';

import AppRouter from '../../routes';
import SessionLoader from 'containers/SessionLoader';
import LocaleIntlProvider from 'containers/LocaleIntlProvider';
// import ConnectedSyncCaller from './FloodlightSyncCaller';

class App extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { store, history } = this.props;

    // Scroll to top when changing page
    history.listen(_ => {
      window.scrollTo(0, 0);
    });

    return (
      <Provider store={store}>
        <LocaleIntlProvider>
          <ConnectedRouter history={history}>
            <MuiThemeProvider muiTheme={MuiTheme}>
              <SessionLoader>
                {/* <ConnectedSyncCaller /> */}
                <AppRouter />
              </SessionLoader>
            </MuiThemeProvider>
          </ConnectedRouter>
        </LocaleIntlProvider>
      </Provider>
    );
  }
}

App.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default App;
